export default "__VITE_ASSET__C29WKQMc__"